import { ProductTypeUid } from '@gelato-api-ui/core/product-catalogue/product-type-uid.enum';

export const wallArtProductTypeUids = [
  ProductTypeUid.ACRYLIC_PRINT,
  ProductTypeUid.ALUMINUM_PRINT,
  ProductTypeUid.CANVAS,
  ProductTypeUid.FOAM_PRINT,
  ProductTypeUid.FRAMED_POSTER,
  ProductTypeUid.FRAMED_POSTER_WITH_PASSEPARTOUT,
  ProductTypeUid.MOUNTED_FRAMED_POSTER,
  ProductTypeUid.MOUNTED_FRAMED_POSTER_WITH_PASSEPARTOUT,
  ProductTypeUid.POSTER,
  ProductTypeUid.POSTER_WITH_HANGER,
  ProductTypeUid.WOOD_PRINT,
];
